<template>
  <div class="col-12" style="height: 100%;">
    <div style="height: 92%;overflow: scroll;">
      <div class="col-12" style="padding:0px">
        <span v-if="patient && patient.myDoctors && patient.myDoctors.length > 0">
          <div class="doctor-row" v-for="doctor in patient.myDoctors" :key="doctor._id">
            <div @click="selectDoctorForBooking(doctor.userId)">
              <dynamic-image v-if="doctor.profileImage" :file-id="doctor.profileImage" image-style="height: 3.5em;width: 3.5em;border-radius: 100%;">
              </dynamic-image>
              <div v-else class="doctor-avatar-icon">
                <i class="fa fa-user-md"></i>
              </div>
            </div>
            <span class="mt-2" style="font-size: 1.3em;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 90%;">
              {{ $t("message.Dr") }} . {{ doctor.fullName }}
            </span>
            <i style=" color: red;margin-left: 0.8em;font-size: 1.2em;" class="el-icon-delete" @click="removeDoctor(doctor)"></i>
          </div>
        </span>
        <div style="margin-top:1em;font-size: 1.3em;text-align: center;" v-else>
          <span>
            {{ $t('message.No doctors added yet') }}
          </span>
        </div>
      </div>
    </div>
    <div class="my-doctor-card">
      <modal :show.sync="SHOW_DOCTOR_MODAL" headerclasses="justify-content-center">
        <my-doctor-card v-if="SHOW_DOCTOR_MODAL" :doctor="DOCTOR"></my-doctor-card>
      </modal>
    </div>

    <n-button type="primary" round class="add-doctors-btn" @click.native="doctorSelectionModalOpen">
      <i class="fas fa-plus"></i> {{ $t('message.Add Doctors') }}
    </n-button>

    <div class="row" style="margin-top: 4em;">
      <div class="col-12">
        <h6>Suggested Doctors</h6>
        <div v-if="suggestedDoctors && suggestedDoctors.length > 0">
          <div style="" class="doctor-row" v-for="doctor in suggestedDoctors" :key="doctor._id">
            <div @click="selectDoctorForBooking(doctor._id)" style="">
              <dynamic-image v-if="doctor.profileImage" :file-id="doctor.profileImage" image-style="height: 3.5em;width: 3.5em;border-radius: 100%;">
              </dynamic-image>
              <div v-else class="doctor-avatar-icon">
                <i class="fa fa-user-md"></i>
              </div>
            </div>
            <span class="mt-2" style="font-size: 1.3em;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 90%;">
              {{ $t("message.Dr") }} . {{ doctor.firstName }} {{ doctor.lastName }}
            </span>
            <i style="color: green;margin-left: 0.8em;font-size: 2em;" class="el-icon-circle-plus-outline" @click="addDoctor(doctor)"></i>
          </div>
        </div>
      </div>
    </div>

    <modal :show.sync="SHOW_DOCTOR_SELECTION_MODAL" headerclasses="justify-content-center" @close="onDoctorSelectionModalClosed()">
      <h5 slot="header" class="title title-up">{{ $t('message.Add Doctors') }}</h5>
      <div style="max-height: 80vh;overflow: scroll;">
        <div class="row pl-3 pr-3">
          <div class="col-3" id="doctor-gender-dropdown">
            <drop-down tag="div" :icon="genderIconClass" titleClass="menu-text" position="left">
              <a class="dropdown-item" @click="selectDoctorGender('all')"><i class="fa fa-users"></i> {{ $t("message.All Doctors") }}</a>
              <a class="dropdown-item" @click="selectDoctorGender('male')"><i class="fa fa-male"></i>{{ $t("message.Male Doctors") }}</a>
              <a class="dropdown-item" @click="selectDoctorGender('female')"><i class="fa fa-female"></i>{{ $t("message.Female Doctors") }}</a>
            </drop-down>
          </div>

          <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="col-9 pl-0">
            <cool-select class="custom-input" :placeholder="$t('message.Search doctor by name, speciality or condition')" :items="doctors" v-model="selectedDoctor" @search="searchDoctors" :resetSearchOnBlur="false" @keyup="coolSelectOnKeyUp" ref="doctorSearch">
              <template slot="no-data">
                <div v-show="doctorSearch && searchedDoctors && searchedDoctors.length < 1"> {{ $t("message.No doctors found") }}</div>
              </template>
            </cool-select>
          </div>

        </div>

        <div class="row pl-3 pr-3">
          <div class="col-md-6 col-lg-4 d-flex" v-for="doctor in searchedDoctors" :key="doctor._id">
            <doctor-details-card :doctor="doctor">
              <template v-slot:footer>
                <div style="width: 100%;display: flex;justify-content: space-around;">
                  <n-button type="danger" round class="mt-auto" style="width: fit-content" v-if="isDoctorAdded(doctor._id)" @click.native="removeDoctor(doctor)">Remove</n-button>
                  <n-button type="primary" round v-else class="mt-auto" style="width: fit-content" @click.native="addDoctor(doctor)">Add</n-button>
                </div>
              </template>
            </doctor-details-card>
          </div>

          <div class="col-12 pb-5" v-if="searchedDoctors && searchedDoctors.length > 0">
            <n-pagination v-if="totalPages > 1" :page-count="totalPages" v-model="pageNumber"></n-pagination>
          </div>
        </div>
        <div class="row pl-3 pr-3">
          <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="col-12">
            <hr>
            <h4>{{ $t("message.Specialities") }}</h4>
          </div>

          <!-- List of specilaities -->
          <div class="col-12">
            <div v-if="!SHOW_DOCTORS_OF_SPECIALITY" class="row">
              <div class="col-md-6 col-lg-3" v-for="speciality in specialities" :key="speciality._id">
                <card style="
                        height: 100px;
                        cursor: pointer;
                        border-radius: 5px;
                        overflow: hidden;
                      " @click.native="getDoctorsOfSpeciality(speciality)">
                  <img v-if="!speciality.backgroundImage" src="@/assets/img/cardiology.jpg" style="
                          position: absolute;
                          top: 0px;
                          bottom: 0px;
                          left: 0px;
                          filter: brightness(50%);
                          height: 100%;
                          width: 100%;
                        " />
                  <dynamic-image v-if="speciality.backgroundImage" :file-id="speciality.backgroundImage" image-style="position: absolute;
                          top: 0px;
                          bottom: 0px;
                          left: 0px;
                          filter: brightness(50%);
                          height: 100%;
                          width: 100%;
                          background-size: cover;">
                  </dynamic-image>
                  <div class="row">
                    <div class="col-12 text-center">
                      <h6 class="card-title mt-3" style="color: #fff; font-size: larger">
                        {{ speciality.name }}
                      </h6>
                    </div>
                  </div>

                  <!-- <h6 class="card-subtitle mb-2 text-muted" style="font-size: smaller;">{{ doctor.specialityText || '--' }}</h6>
                <p class="card-text">{{ $t('message.waiting5') }}: {{ doctor.registration.number }}, {{ doctor.registration.city }}</p>-->
                  <p class="card-text">
                    {{ speciality.description || "--" }}
                  </p>
                  <!-- <a href="#" class="card-link" style="bottom: 0px;position: absolute;width: 100%">
                                    <n-button type="primary" round="">Book Appointment</n-button>
                </a>-->
                </card>
              </div>

              <div class="col-12 pb-5" v-if="specialities && specialities.length > 0">
                <n-pagination v-if="specialitiesPagination.totalPages > 1" :page-count="specialitiesPagination.totalPages" v-model="specialitiesPagination.pageNumber"></n-pagination>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row" style="width: 100%" v-if="SHOW_DOCTORS_OF_SPECIALITY == true">
              <div class="col-1" @click="SHOW_DOCTORS_OF_SPECIALITY = false">
                <i class="now-ui-icons arrows-1_minimal-left"></i>
              </div>
              <div class="col-6">
                <h6 v-if="selectedSpeciality" style="line-height: 21px">
                  {{ selectedSpeciality.name }}
                </h6>
              </div>
            </div>
          </div>

          <!-- List of doctors of selected speciality -->
          <div class="col-12">
            <div v-if="SHOW_DOCTORS_OF_SPECIALITY" class="row">
              <div class="col-md-6 col-lg-4 d-flex" v-for="doctor in specialityDoctors" :key="doctor._id">
                <doctor-details-card :doctor="doctor">
                  <template v-slot:footer>
                    <div style="width: 100%;display: flex;justify-content: space-around;">
                      <n-button type="danger" round class="mt-auto" style="width: fit-content" v-if="isDoctorAdded(doctor._id)" @click.native="removeDoctor(doctor)">Remove</n-button>
                      <n-button type="primary" v-else round class="mt-auto" style="width: fit-content" @click.native="addDoctor(doctor)">Add</n-button>
                    </div>
                  </template>
                </doctor-details-card>
              </div>

              <div class="col-12 pb-5 text-center" v-if="specialityDoctors.length < 1">
                <div class="row">
                  <div class="col-12">
                    <i style="color: #fff; font-size: large">{{
                      $t("message.No doctors available for this speciality")
                    }}</i>
                  </div>
                  <div class="col-12">
                    <doctor-patient-svg style="height: 10em; width: 100%; margin-top: 20em"></doctor-patient-svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>


<script>
import DoctorPatientSvg from "../components/svg_images/DoctorPatientSvg.vue";
export default {
  data() {
    return {
      SHOW_DOCTOR_SELECTION_MODAL: false,
      genderIconClass: "fa fa-users",
      doctorGenderFilter: "",
      SHOW_DOCTORS_OF_SPECIALITY: false,
      selectedSpeciality: null,
      searchedDoctors: [],
      doctors: [],
      specialities: [],
      doctorSearch: "",
      specialitiesPagination: {
        pageNumber: 1,
        totalPages: 0,
        pageSize: 12,
      },
      specialityDoctors: [],
      selectedDoctor: null,
      SHOW_DOCTOR_MODAL: false,
      DOCTOR: null,
      previousAppointmentDoctors: [],
    };
  },

  components: {
    DoctorPatientSvg,
  },

  computed: {
    patient() {
      return this.$store.state.patient;
    },

    suggestedDoctors() {
      return this.previousAppointmentDoctors.filter((prevDoc) => {
        return !this.isDoctorAdded(prevDoc._id);
      });
    },
  },

  methods: {
    async selectDoctorForBooking(id) {
      this.DOCTOR = await this.$store.dispatch("getUserById", id);
      this.SHOW_DOCTOR_MODAL = true;
    },
    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.doctorSearch.$el.querySelector("input").blur();
      }
    },
    async doctorSelectionModalOpen() {
      this.SHOW_DOCTOR_SELECTION_MODAL = true;
      let response = await this.$store.dispatch("getSpecialities", {
        pageNumber: this.specialitiesPagination.pageNumber,
        pageSize: this.specialitiesPagination.pageSize,
      });
      this.specialities = response.data;
      this.specialitiesPagination.totalPages = response.totalPages;
    },
    onDoctorSelectionModalClosed() {
      this.doctorSearch = "";
      this.specialityDoctors = [];
      this.searchedDoctors = [];
      this.SHOW_DOCTORS_OF_SPECIALITY = false;
    },
    selectDoctorGender(gender) {
      if (gender == "male") {
        this.doctorGenderFilter = "male";
        this.genderIconClass = "fa fa-male";
      } else if (gender == "female") {
        this.doctorGenderFilter = "female";
        this.genderIconClass = "fa fa-female";
      } else if (gender == "all") {
        this.doctorGenderFilter = "";
        this.genderIconClass = "fa fa-users";
      }
      if (this.SHOW_DOCTORS_OF_SPECIALITY) {
        this.getDoctorsOfSpeciality(this.selectedSpeciality);
      } else {
        this.searchDoctors(this.doctorSearch);
      }
    },
    async getDoctorsOfSpeciality(speciality) {
      this.doctorSearch = "";
      this.searchedDoctors = [];
      this.selectedSpeciality = speciality;
      this.SHOW_DOCTORS_OF_SPECIALITY = true;
      let query = {
        specialityId: speciality._id,
      };
      if (this.doctorGenderFilter) {
        query.gender = this.doctorGenderFilter;
      }
      try {
        let response = await this.$store.dispatch(
          "getDoctorsBySpeciality",
          query
        );
        this.specialityDoctors = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    async searchDoctors(searchString) {
      try {
        this.doctorSearch = searchString;
        this.searchedDoctors = [];
        let query = {
          searchString: searchString,
        };

        if (this.doctorGenderFilter) {
          query.gender = this.doctorGenderFilter;
        }

        if (query.searchString) {
          let response = await this.$store.dispatch("searchDoctors", query);

          this.searchedDoctors = response.data;
          this.totalPages = response.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addDoctor(doctor) {
      try {
        let res = await this.$store.dispatch("addMyDoctor", {
          doctorId: doctor._id,
          userId: this.user._id,
        });
        if (res && res._id) {
          this.$store.commit("setState", {
            stateName: "patient",
            stateValue: res,
          });
        }
        swal.fire({
          title:
            this.$t("message.Dr") +
            " . " +
            doctor.firstName +
            " " +
            doctor.lastName +
            " added",
          text: "",
          type: "success",
          timer: 3000,
        });
      } catch (e) {
        swal.fire({
          title: "Error",
          text: "Couldn't add doctor!",
          type: "error",
          timer: 3000,
        });
        console.log(e);
      }
    },
    async removeDoctor(doctor) {
      swal
        .fire({
          type: "info",
          title: "Are you sure that you want to remove this doctor?",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then(async (result) => {
          if (result && result.value) {
            try {
              let res = await this.$store.dispatch("removeMyDoctor", {
                doctorId: doctor.userId || doctor._id,
                userId: this.user._id,
              });
              if (res && res._id) {
                this.$store.commit("setState", {
                  stateName: "patient",
                  stateValue: res,
                });
              }
              swal.fire({
                title:
                  this.$t("message.Dr") +
                  " . " +
                  (doctor.fullName ||
                    doctor.firstName + " " + doctor.lastName) +
                  " removed",
                type: "success",
                timer: 3000,
              });
            } catch (e) {
              swal.fire({
                title: "Error",
                text: "Couldn't remove doctor!",
                type: "error",
                timer: 3000,
              });
              console.log(e);
            }
          }
        });
    },
    isDoctorAdded(id) {
      if (id && this.patient && this.patient.myDoctors) {
        let found = this.patient.myDoctors.some((doc) => doc.userId === id);
        if (found) {
          return true;
        }
      }
      return false;
    },
  },

  async mounted() {
    if (this.user && this.user.gender == "female") {
      this.selectDoctorGender(this.user.gender);
    }

    console.log("getting docs");

    this.previousAppointmentDoctors = await this.$store.dispatch(
      "getPreviousAppointmentDoctors",
      {
        userId: this.user._id,
      }
    );
  },
};
</script>

<style scoped>
/deep/.my-doctor-card .modal-body {
  margin-top: 2em !important;
}

.add-doctors-btn {
  position: fixed;
  bottom: 2em;
  left: 50%;
  transform: translateX(-50%);
}

.doctor-avatar-icon {
  background: var(--color-primary);
  padding: 1em;
  border-radius: 50%;
  color: #fff;
  height: 3.5em;
  width: 3.5em;
  text-align: center;
}

.doctor-avatar-icon i {
  font-size: 1.5em;
}

.doctor-row {
  margin-top: 1.5em;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.doctor-row span {
  flex-grow: 1;
  padding-inline-start: 1em;
}
</style>
